import { cwslapi } from "../index";



// 获取签到列表 - 签到活动管理
export const getSignInListApi = (data) => {
  return cwslapi({
    url: "/signIn/getSignInList",
    method: "post",
    data,
  });
};


// 每日签到 - 签到活动管理
export const getdoSigninApi = (data) => {
    return cwslapi({
      url: "/signIn/doSignin",
      method: "post",
      data,
    });
  };
 

// 领取全勤奖励 - 签到活动管理
export const getfullPrizeApi = (data) => {
    return cwslapi({
      url: "/signIn/getfullPrize",
      method: "post",
      data,
    });
  };